import getCommonProps from "../../primitives/ButtonPrimitive/common/getCommonProps";
const getButtonLinkCommonProps = props => {
  if (!props.compact) return getCommonProps(props);
  return {
    ...getCommonProps(props),
    padding: "0"
  };
};
export default getButtonLinkCommonProps;